import styles from "./ErrorHandler.module.css";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ErrorHandler({ title, desc }) {
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	const isRoot = location.pathname === "/";

	const handleHome = () => {
		// If already on root → refresh
		if (isRoot) {
			window.location.reload();
		} else {
			navigate("/", { replace: true });
		}
	};

	const handleGoBack = () => {
		// If on root → refresh
		if (isRoot) {
			window.location.reload();
			return;
		}

		// Normal behavior
		if (window.history.length > 2) navigate(-1);
		else navigate("/", { replace: true });
	};

	return (
		<div className={styles["error_container"]}>
			<div className={styles["text_container"]}>
				<WarningAmberIcon sx={{ fontSize: 90, color: "#ff0f0f" }} />
				<h1 className={styles["title_style"]}>
					{t("Oops!")} {title}
				</h1>

				<div className={styles["text_style"]}>
					<div>{desc}</div>
				</div>

				<div className="btn-group" style={{ justifyContent: "center" }}>
					{/* Home button */}
					<button className="btn btn-primary" onClick={handleHome}>
						{t("Go to homepage")}
					</button>

					{/* Back button */}
					<button className="btn btn-secondary" onClick={handleGoBack}>
						{t("Go Back")}
					</button>
				</div>
			</div>
		</div>
	);
}
